// src/data/dashboardData.js

export const barChartData = [
    { day: "Mon", online: 400000, offline: 300000 },
    { day: "Tue", online: 300000, offline: 200000 },
    { day: "Wed", online: 450000, offline: 350000 },
    { day: "Thu", online: 500000, offline: 400000 },
    { day: "Fri", online: 700000, offline: 550000 },
    { day: "Sat", online: 600000, offline: 500000 },
    { day: "Sun", online: 800000, offline: 600000 },
];

export const trafficData = [
    { hour: "00", visitors: 150 },
    { hour: "04", visitors: 100 },
    { hour: "08", visitors: 200 },
    { hour: "12", visitors: 280 },
    { hour: "16", visitors: 320 },
    { hour: "20", visitors: 240 },
];  
  
export const lineChartData = [
    { date: "1st", lastMonth: 600, thisMonth: 1600 },
    { date: "6th", lastMonth: 800, thisMonth: 1200 },
    { date: "11th", lastMonth: 200, thisMonth: 1400 },
    { date: "16th", lastMonth: 200, thisMonth: 1000 },
    { date: "21st", lastMonth: 400, thisMonth: 1400 },
    { date: "26th", lastMonth: 400, thisMonth: 800 },
    { date: "31st", lastMonth: 600, thisMonth: 2000 },
];
  
export const taskData = [
    { name: "Landing Page Design", completed: false },
    { name: "Dashboard Builder", completed: true },
    { name: "Mobile App Design", completed: true },
    { name: "Illustrations", completed: false },
];
  
export const churnData = [
    { month: "Jan", churn: 9, expansion: 11 },
    { month: "Feb", churn: 7, expansion: 3 },
    { month: "Mar", churn: 8, expansion: 9 },
    { month: "Apr", churn: 2, expansion: 9 },
    { month: "May", churn: 4, expansion: 10 },
    { month: "Jun", churn: 6, expansion: 5 },
    { month: "Jul", churn: 3, expansion: 11 },
    { month: "Aug", churn: 8, expansion: 9 },
    { month: "Sep", churn: 13, expansion: 6 },
    { month: "Oct", churn: 7, expansion: 10 },
    { month: "Nov", churn: 4, expansion: 15 },
    { month: "Dec", churn: 1, expansion: 13 },
]